import { useTranslation } from 'react-i18next';
import {
  PageContainer,
  PageFooter,
  PageHeader,
} from '../../../shared_components';
import { Button, Stack, Text } from '@mantine/core';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

export const ViewInvoices = () => {
  const { t } = useTranslation(['common', 'profile']);

  //TODO CBYN-141 implement properly once endpoints are implemented
  const invoices = ['2025_08_4.pdf', '2025_11_17.pdf', '2025_11_23.pdf'];

  const invoiceList = () => {
    return invoices.map((invoice) => {
      return (
        <tr>
          <td style={{ paddingBottom: 'var(--mantine-spacing-xs)' }}>
            <Text style={{ paddingRight: 'var(--mantine-spacing-md)' }}>
              {invoice}
            </Text>
          </td>
          <td style={{ paddingBottom: 'var(--mantine-spacing-xs)' }}>
            <Button
              variant="inline-text"
              leftSection={
                <SaveAltIcon
                  style={{ fill: 'var(--mantine-color-innovationPurple-0)' }}
                />
              }
            />
          </td>
        </tr>
      );
    });
  };

  return (
    <PageContainer>
      <PageHeader
        title={t('profile:view_invoices_title')}
        message={t('profile:view_invoices_message')}
      />
      <Stack>
        <table style={{ width: 'fit-content' }}>
          <tbody>{invoiceList()}</tbody>
        </table>
      </Stack>
      <PageFooter leftOnClick={() => window.history.back()} hideRight />
    </PageContainer>
  );
};
